export const userDataDraftOrdersKey = "viewed-draft-orders";
export const userDataDraftOrdersSubKey = "order_ids";
